export default {
    sim_providers_main_title: 'Proveedores de Sim',
    sim_providers_main_id: 'Id',
    sim_providers_main_name: 'Nombre',
    sim_providers_add: 'Agregar Proveedor Sim',
}